import { Link } from 'react-router-dom';
import mascot from '../img/the-ball.png';

export default function SiteHeader() {
  return (
    <header className="legal-header">
      <div className="content-well">
        <div className="hero-topbar">
          <Link to="/" className="hero-brand" aria-label="Go to home">
            <img className="gradient-mascot" src={mascot} alt="" />
            <div className="hero-brand-text">
              <p className="hero-title">Wreckoning Ball</p>
            </div>
          </Link>
          <p className="hero-subtitle hero-subtitle-right">Woo Adjacent</p>
        </div>
      </div>
    </header>
  );
}
